import moment from 'moment';
import { Box, ListItem, Tooltip, Typography } from '@mui/material';
import { tooltipSx } from '../../components/shared/jernyTooltipStyling';
import calendarEngine from '../Core/CalendarEngine';
import { drawerItemSx, drawerLabelSx, drawerMetaSx, drawerDotSx } from './upcomingDrawerSx';

/**
 * Two-column meta row — left label, optional right label.
 *
 * @param {{ left: string, leftSx: object, right?: string, rightSx?: object }} props
 */
const MetaRow = ({ left, leftSx, right, rightSx }) => (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography sx={leftSx}>{left}</Typography>
        {right && <Typography sx={rightSx}>{right}</Typography>}
    </Box>
);

/**
 * UpcomingDrawerItem — single row in UpcomingDrawer.
 * Click calls calendarEngine.show(event) directly — no onX prop
 * (Development.Patterns rk=e265293c, no engine mutation via props).
 *
 * @param {{ event: CalEventObj }} props
 */
export default function UpcomingDrawerItem({ event }) {
    /**
     * Pops out this event from the drawer back onto the floating cards.
     */
    const handleRestore = () => {
        calendarEngine.show(event);
    };

    const days = moment(event.date).diff(moment().startOf('day'), 'days');
    const dayLabel = days === 0 ? 'today' : `${days}d`;
    const dateMeta = `${event.date}${event.time ? ' · ' + event.time : ''}`;

    return (
        <ListItem sx={drawerItemSx} disablePadding>
            {/* <Box sx={drawerDotSx(event.cat)} /> */}

            <Tooltip title="Pop out" componentsProps={tooltipSx}>
                <Box onClick={handleRestore} sx={{ flex: 1, cursor: 'pointer' }}>
                    {/* <MetaRow left={event.label} leftSx={drawerLabelSx} right={event.cat} rightSx={drawerMetaSx} /> */}

                    <MetaRow left={event.label} leftSx={drawerLabelSx} rightSx={drawerMetaSx} />
                    <MetaRow left={dateMeta} leftSx={drawerMetaSx} right={dayLabel} rightSx={drawerMetaSx} />
                </Box>
            </Tooltip>
        </ListItem>
    );
}
